exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#filterLongPlainText {\n  word-wrap: break-word;\n  max-height: 400px;\n  overflow: auto;\n}\n.customCheckH {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  padding-top: 1rem;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/VCopayEPAFilterItemHorizon.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;CACnB","file":"VCopayEPAFilterItemHorizon.vue","sourcesContent":["\n#filterLongPlainText {\n  word-wrap: break-word;\n  max-height: 400px;\n  overflow: auto;\n}\n.customCheckH {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  padding-top: 1rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6a7045c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VCopayEPAFilterItemHorizon.vue
// module id = /wFz
// module chunks = 1